.wrapper {
  width: 100%;
  padding: 0 20px 0;
}

.content {
  margin: 0 auto;
}

.title {
  margin: 0 0 30px;
  color: #221e1a;
  text-align: center;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: clamp(24px, 6vw, 32px);
  font-weight: 700;
  line-height: 1.2;

  span {
    color: var(--ed-brand, #ae66f6);
  }
}

.card {
  position: relative;
  width: 100%;
  padding: 0 3px 3px;
  border-radius: 14px;
  background: url(./img/bg.png) no-repeat;
  background-position: top;
  background-size: 100% 100%;
  overflow: visible;
}

.header {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 43% 7px 16px;
  z-index: 2;

  p {
    color: #fffbf2;
    font-family: 'SF Pro Text', 'SF Pro', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 860;
    line-height: 16px;
    letter-spacing: 0.26px;
    text-transform: uppercase;
  }

  img {
    width: 12px;
    min-width: 12px;
    margin-bottom: 2px;
  }
}

.avatarWrapper {
  position: absolute;
  top: -26px;
  right: 7px;
  width: 72px;
  height: 72px;
  border: 2px solid var(--ed-border, #221E1A);
  z-index: 3;
  background: #F0930C;
  border-radius: 50%;
}

.avatarImageWrapper {
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.avatarWrapper::before {
  content: "";
  display: block;
  background: url(./img/label.png) no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  bottom: -6px;
  right: 0;
  width: 25px;
  height: 25px;
}

.avatar {
  object-fit: contain;
}

.cardBody {
  position: relative;
  z-index: 1;
  border-radius: 14px;
  background: #fffbf2;
  padding: 24px 16px 16px 24px;
}

.row {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  color: #221e1a;
  font-size: 16px;
  line-height: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--ed-border, #D9D3C5);
  margin-left: 24px;

  & + & {
    margin-top: 16px;
  }
}

.row:last-child {
  border: none;

  .value {
    padding: 4px 12px;
    border-radius: 12px;
    background: #29A073;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: -0.036px;
    text-transform: uppercase;
    color: #FFFBF2;
  }
}

.rowIcn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -34px;
  width: 20px;
}

.value {
  min-width: 0;
  font-weight: 700;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  text-align: right;
}

@media (min-width: 376px) {
  .header {
    padding: 7px 43% 7px 16px;
  }
}

@media (max-width: 360px) {
  .wrapper {
    padding-left: 16px;
    padding-right: 16px;
  }

  .title {
    margin-bottom: 26px;
    font-size: 22px;
  }

  .header span {
    font-size: 12px;
  }

  .avatar {
    right: 10px;
    width: 84px;
    height: 84px;
  }

  .cardBody {
    padding-left: 18px;
    padding-right: 14px;
  }

  .row {
    font-size: 15px;
    line-height: 19px;
  }
}


@media (max-width: 365px) {
  .header {
    padding: 7px 40% 7px 16px;
  }
}